import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
const store = createStore({
  plugins: [createPersistedState()],
  state: {
    EmailID: "",
    currentUsetDetailsObject: {},
    organizationDetailsObject: {},
  },

  getters: {
    get_user_email_id: (state) => state.EmailID,
    get_current_user_details: (state) => state.currentUsetDetailsObject,
    get_organization_details: (state) => state.organizationDetailsObject,
  },
  mutations: {
    SET_USER_EMAIL_ID(state, username) {
      state.EmailID = username;
    },
    SET_CURRENT_USER_DETAILS(state, userDetails) {
      state.currentUsetDetailsObject = userDetails;
    },
    SET_ORGANIZATION_DETAILS(state, orgDetails) {
      state.organizationDetailsObject = orgDetails;
    },
  },
  actions: {},
  modules: {},
});

export default store;
